const path = "/ava/resposta";
const endpoint = {
  porInstituicao: (id_instituicao, id_questionario) => `${path}/por-instituicao/${id_instituicao}/${id_questionario}`,
};

export default endpoint;
